var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"preview-link",attrs:{"to":{name: 'shipping', params: {'id': _vm.shipping.id}}}},[_c('shipping-list-item',{attrs:{"shipping":_vm.shipping,"shipping-types":_vm.shippingTypes,"isPreview":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }